import script from "./EmptyTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyTag.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyTag.vue?vue&type=style&index=0&id=5816ab15&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5816ab15"]])

export default __exports__